import { useAudioFeatureFlags } from '@confluence/audio/entry-points/useAudioFeatureFlags.ts';

export const useHasAudioButton = (isAIEnabledForContent: boolean): boolean => {
	const { isAIPolicyAndBrowserSupportEnabled, isAudioV3Enabled, isAudioBylineEntrypointEnabled } =
		useAudioFeatureFlags();
	// Only show audio entrypoint in sidebar if:
	// 1. AI is Enabled for content
	// 2. AI Policy and browser support are enabled AND
	// 3. [Audio V3 is disabled] OR [Audio Byline Entrypoint is disabled]
	//
	// Truthy cases:
	// - AI Enabled; Audio & AI Policy supported; Audio V3 disabled; Audio Byline Entrypoint disabled => Audio V2 experience
	// - AI Enabled; Audio & AI Policy supported; Audio V3 disabled; Audio Byline Entrypoint enabled  => Audio V2 experience
	// - AI Enabled; Audio & AI Policy supported; Audio V3 enabled; Audio Byline Entrypoint disabled  => Audio V3 experience
	//
	// Falsy cases:
	// - AI disabed;													  							  => No audio entrypoint
	// - Audio & AI Policy disabled;									  							  => No audio entrypoint
	// - AI Enabled; Audio & AI Policy supported; Audio V3 enabled; Audio Byline Entrypoint enabled   => Audio V3-Byline experience
	return (
		isAIEnabledForContent &&
		isAIPolicyAndBrowserSupportEnabled &&
		(!isAudioV3Enabled || !isAudioBylineEntrypointEnabled)
	);
};
